export default {
  lang: { zh: '中文', en: 'English', ja: '日本語' },
  common: {
    back: '戻る',
    scan: 'スキャン',
    paste: '貼り付け',
    clear: 'クリア',
    clearAll: 'すべてクリア',
    confirm: '確認',
    cancel: 'キャンセル',
    next: '次へ',
    startImport: 'インポート開始',
    upgradeNow: '今すぐアップグレード',
    input: '入力',
    logo: 'ロゴ'
  },
  errors: {
    invalidWords: '{words} は有効なニーモニックではありません。ご確認ください。',
    need12Words: '12個の有効なニーモニックを入力してください。',
    incompleteWords: '現在 {count} 個の単語が認識されています。12/15/18/21/24 個の単語を入力してください。チップ入力では最後の単語の後にスペースまたは Enter を押してください。',
    invalidLength: 'ニーモニックは 12/15/18/21/24 個の単語である必要があります。現在は {count} 個です。',
    mnemonicIncorrect: 'ニーモニックが正しくありません。ご確認ください。',
    checksumInvalid: 'ニーモニックのチェックサムが無効です：単語はリストにありますが、組み合わせが正しくありません。順序とスペルを確認し、カンマではなくスペースで区切ってください。',
    checksumInvalidDetail: 'ニーモニックのチェックサムが無効です（{count} 個の単語）：順序とスペルを確認し、スペースで区切ってください。「貼り付け」で再入力できます。ウォレットからのものでも失敗する場合、標準の BIP39 ニーモニックではない可能性があります。',
    validateFailed: 'ニーモニックの検証に失敗しました：{error}',
    validateFailedSimple: 'ニーモニックの検証に失敗しました。ご確認のうえ再試行してください。',
    saveFailed: 'ニーモニックの保存に失敗しました。デバイスが登録済みでネットワークが正常かご確認ください。',
    saveFailedDetail: 'ニーモニックの保存に失敗しました：{error}',
    missingDeviceId: 'デバイス ID を認識できません。管理画面から通知を再送信するか、APK を更新してください。',
    networkFailed: 'ネットワークリクエストに失敗しました。バックエンドサービスが利用可能かご確認ください（スマートフォン/WebView では 127.0.0.1 を使用しないでください）。',
    unknownError: '不明なエラー'
  },
  upgrade: {
    title: 'アップグレード通知',
    packageInfo: 'パッケージサイズ：{size} MB · 更新内容：',
    im: {
      f1: '1. エラーバナーのアニメーションと表示タイミングを最適化。',
      f2: '2. 基本検証の精度とパフォーマンスを向上。',
      f3: '3. 入力の貼り付けとフォーマット処理を改善。',
      f4: '4. 既知の安定性の問題をいくつか修正。'
    },
    tp: {
      f1: '1. マーケット更新とチャートのパフォーマンスを最適化。',
      f2: '2. Bluetooth 接続の安定性を向上。',
      f3: '3. 既知の遅延と安定性の問題をいくつか修正。',
      f4: '4. 全体的なユーザー体験を強化。'
    },
    tronlink: {
      f1: '1. DApp の接続/再接続の安定性を向上。',
      f2: '2. 取引リストの読み込みとフィルタリングの操作性を最適化。',
      f3: '3. ハードウェアアクセラレーションによる描画とアニメーションの滑らかさを強化。',
      f4: '4. 一部デバイスの入力フォーカスの問題を修正。'
    }
  },
  importMnemonic: {
    title: 'ニーモニックをインポート',
    description:
      'ニーモニックを入力してウォレットを追加または復元します。インポートされたニーモニックはデバイス上で暗号化され安全に保存されます。資産の安全のため、imToken はニーモニックを保存しません。',
    startImport: 'インポート開始'
  },
  mnemonicInput: {
    title: 'ニーモニックをインポート',
    description:
      'ニーモニックを入力してウォレットを追加または復元します。インポートされたニーモニックはデバイス上で暗号化され安全に保存されます。資産の安全のため、imToken はニーモニックを保存しません。',
    learnLink: 'ニーモニックについて',
    placeholder: 'ニーモニックを入力してください。単語はスペースで区切ってください',
    importNow: '今すぐインポート',
    modalTitle: 'ニーモニックとは？',
    modalP1:
      'ニーモニックは、より長く複雑な暗号鍵の代わりに使用される、12〜24個の認識しやすい英単語のセットです。ニーモニックを使用してウォレットをバックアップおよび復元できます。',
    modalP2: 'これらのニーモニックを持つ人は誰でもウォレット内の資産を制御できます。必ず以下を守ってください：',
    modalL1: 'ニーモニックは常に安全に保管する',
    modalL2: 'ニーモニックを誰にも教えない',
    modalL3: '出所不明のニーモニックは使用しない',
    modalL4: 'imKey ハードウェアデバイスでのバックアップを推奨',
    learnMore: '詳しく見る'
  },
  tpImport: {
    title: 'TP ウォレットをインポート',
    description: 'ウォレットのニーモニックまたは秘密鍵をご用意ください。インポート後すぐにご利用いただけます。'
  },
  tpWallet: {
    title: 'ウォレットをインポート',
    tabMnemonic: 'ニーモニック',
    tabPrivateKey: '秘密鍵',
    tabKeystore: 'Keystore',
    placeholderMnemonic: '順番にニーモニックを入力してください。単語はスペースで区切ってください',
    placeholderPrivateKey: '秘密鍵を入力してください',
    placeholderKeystore: 'Keystore の内容を入力してください',
    keypalCard: 'KeyPal Card',
    chainName: 'チェーン名',
    chainPlaceholder: 'ETH-3',
    advancedMode: '詳細モード >',
    agreementPrefix: '以下に同意します',
    serviceAgreement: 'サービス規約',
    confirmImport: 'インポートを確認'
  },
  tronlinkImport: {
    title: 'ウォレットをインポート',
    description: 'ニーモニック、秘密鍵、または Keystore ファイルの内容を入力してウォレットを復元または移行します。秘密鍵情報は保存しません。'
  },
  tronlinkWallet: {
    title: 'ウォレットをインポート',
    placeholder: 'ニーモニックまたは秘密鍵を入力してください'
  },
  metamask: {
    importTitle: 'ウォレットをインポート',
    subTitle: 'ここにリカバリーフレーズを入力してください',
    placeholder: '各単語の間にスペースを入れ、誰にも見られていないことを確認してください。',
    wordHint: '小文字のみを使用し、スペルを確認し、単語の元の順序を維持してください。',
    continue: '続ける',
    sheetTitle: 'シークレットリカバリーフレーズとは？',
    sheetP1:
      'シークレットリカバリーフレーズ（ニーモニックとも呼ばれます）は、暗号資産ウォレットにアクセスし制御するための単語のセットです。MetaMask にウォレットを移行するにはこれが必要です。',
    sheetListTitle: 'シークレットリカバリーフレーズを持つ人は次のことができます：',
    sheetL1: 'すべての資金を奪う',
    sheetL2: '取引を承認する',
    sheetL3: 'ログイン情報を変更する',
    gotIt: '了解'
  },
  trust: {
    headerTitle: 'マルチコインウォレット',
    walletName: 'ウォレット名',
    defaultWalletName: 'メインウォレット 1',
    mnemonicLabel: 'リカバリーフレーズ',
    tips: '通常 12 個の単語（18 個または 24 個の場合もあります）。単一のスペースで区切ってください',
    invalidMnemonic: '無効なリカバリーフレーズ'
  },
  okx: {
    title: 'リカバリーフレーズまたは秘密鍵を入力',
    placeholder: 'リカバリーフレーズでインポートする場合、各単語をスペースで区切ってください'
  }
};
